import { useQuery } from "@apollo/client";
import usePagination from "@/hooks/usePagination";
import { MEMBER_ELECTION_RUNS_QUERY } from "../queries";
import type {
  MemberElectionRunNode,
  MemberElectionRunsQueryResponse,
  MemberElectionRunsQueryVariables
} from "../types";

const EMPTY_RUNS: MemberElectionRunNode[] = [];

export function usePastMemberElectionRuns() {
  const { paginationVariables, createHeaderPagination, createFooterPagination } = usePagination();

  const { data, previousData, loading, error, refetch } = useQuery<
    MemberElectionRunsQueryResponse,
    MemberElectionRunsQueryVariables
  >(MEMBER_ELECTION_RUNS_QUERY, {
    variables: paginationVariables,
    notifyOnNetworkStatusChange: true
  });

  const connection = (data ?? previousData)?.membershipElectionRuns;
  const runs = connection?.nodes ?? EMPTY_RUNS;
  const showLoadError = !!error && !loading;

  return {
    runs,
    loading,
    showLoadError,
    refetch,
    createHeaderPagination: createHeaderPagination(connection),
    createFooterPagination: createFooterPagination(connection)
  };
}
